import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

const Option = Select.Option;

class SelectItem extends React.PureComponent {
  filterOption = (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  renderSelectOptions = () => {
    const { is_option_object_type, options, value_key, name_key } = this.props;
    if (is_option_object_type) {
      return (
        options && options.map((option, index) => {
          return (
            <Option key={index} value={option[value_key]} disabled={option.disabled ? option.disabled : false}>{option[name_key]}</Option>
          );
        })
      );
    } else {
      return (
        options && options.map((option, index) => {
          return (
            <Option key={index} value={option}>{option}</Option>
          );
        })
      );
    }
  };

  render() {
    const { title, title_class, container_class, size, mode, allow_clear, placeholder, value, show_search, loading, select_class, dropdown_class, onChange, onDeselect, message } = this.props;
    return (
      <div className={container_class}>
        {
          title &&
          <p className={`ori-b-mrgn-5 ori-capitalize-first ${title_class}`}>{title}</p>
        }
        <Select size={size} mode={mode} className={`ori-full-width ${select_class}`} dropdownClassName={dropdown_class} showSearch={show_search} allowClear={allow_clear} loading={loading} placeholder={placeholder} filterOption={this.filterOption} value={value} onChange={onChange} onDeselect={onDeselect}>
          {this.renderSelectOptions()}
        </Select>
        {
          message && message.length > 0 &&
          <p className="ori-font-xxs ori-font-danger ori-lr-pad-5">{message}</p>
        }
      </div>
    );
  }
}

SelectItem.propTypes = {
  title: PropTypes.string,
  title_class: PropTypes.string,
  container_class: PropTypes.string,
  size: PropTypes.oneOf(['small', 'default', 'large']),
  mode: PropTypes.oneOf(['default', 'multiple', 'tags']),
  loading: PropTypes.bool,
  allow_clear: PropTypes.bool,
  placeholder: PropTypes.string,
  show_search: PropTypes.bool,
  select_class: PropTypes.string,
  dropdown_class: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  onChange: PropTypes.func,
  onDeselect: PropTypes.func,
  is_option_object_type: PropTypes.bool,
  value_key: PropTypes.string,
  name_key: PropTypes.string,
  message: PropTypes.string,
};

SelectItem.defaultProps = {
  show_search: false,
  allow_clear: false,
  select_class: "ori-font-xs",
  dropdown_class: "",
  container_class: "ori-tb-pad-5 ori-animated ori-fade-in",
  mode: 'default',
  bool: false,
  options: [],
  is_option_object_type: false,
  value_key: 'id',
  name_key: 'name',
  size: 'default'
};

export default SelectItem;


// WEBPACK FOOTER //
// ./src/components/form/selectitem/index.js